module.exports = __webpack_public_path__ + "static/img/ico_handshack_file.837fdf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_handshack_file.png
// module id = qUhI
// module chunks = 1